export var convertSecondsToHours = function (rate) { return rate / 60 / 60; };
